;
export default {
    SERVICE_ID: `service_cj2j0mb`, //userID
    TEMPLATE_ID: `template_jwdqw3g`,         //templateID
    USER_ID:`GrywLkh4ZTz5WnZIn`
    }